import { templateMap } from './custom_final_result_html/CustomFinalResultHtmlTemplateMap'

export default function CustomFinalResultsHtmlGenerator(type='default') {
  this.generate = function() {
    return templateMap[type];
  }
}